import React from "react";
import PropTypes from "prop-types";
import { Divider, Grid, MenuItem, Stack, TextField, Typography } from "@mui/material";

const STATUS_OPTIONS = [
  { value: "geplant", label: "Geplant" },
  { value: "abgesagt", label: "Abgesagt" },
  { value: "abgeschlossen", label: "Abgeschlossen" },
];

export default function StepBasicInfo({ formData, errors, onChange }) {
  const updateField = (fieldName) => (event) => {
    onChange(fieldName, event.target.value);
  };

  return (
    <Stack spacing={2}>
      <Typography variant="h6">Grundlagen</Typography>

      <TextField
        label="Titel"
        value={formData.eventName}
        onChange={updateField("eventName")}
        error={Boolean(errors.eventName)}
        helperText={errors.eventName || ""}
        required
        fullWidth
      />

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Status"
            select
            value={formData.status}
            onChange={updateField("status")}
            fullWidth
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Typ"
            value={formData.eventType}
            onChange={updateField("eventType")}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Beginn"
            type="datetime-local"
            value={formData.eventDateBegin}
            onChange={updateField("eventDateBegin")}
            error={Boolean(errors.eventDateBegin)}
            helperText={errors.eventDateBegin || ""}
            InputLabelProps={{ shrink: true }}
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Ende"
            type="datetime-local"
            value={formData.eventDateEnd}
            onChange={updateField("eventDateEnd")}
            error={Boolean(errors.eventDateEnd)}
            helperText={errors.eventDateEnd || ""}
            InputLabelProps={{ shrink: true }}
            required
            fullWidth
          />
        </Grid>
      </Grid>

      <TextField
        label="Beschreibung"
        value={formData.description}
        onChange={updateField("description")}
        multiline
        minRows={3}
        fullWidth
      />

      <Divider />

      <TextField
        label="Ort / Halle"
        value={formData.locationName}
        onChange={updateField("locationName")}
        fullWidth
      />

      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <TextField
            label="Straße"
            value={formData.street}
            onChange={updateField("street")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label="PLZ"
            value={formData.zip}
            onChange={updateField("zip")}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Stadt"
            value={formData.city}
            onChange={updateField("city")}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Land"
            value={formData.country}
            onChange={updateField("country")}
            fullWidth
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            label="Max. Teilnehmer (optional)"
            type="number"
            value={formData.maxParticipants}
            onChange={updateField("maxParticipants")}
            inputProps={{ min: 0 }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={8}>
          <TextField
            label="Tags (kommagetrennt)"
            value={formData.tags}
            onChange={updateField("tags")}
            helperText="z.B. Seminar, Lehrgang, Wettkampf"
            fullWidth
          />
        </Grid>
      </Grid>
    </Stack>
  );
}

StepBasicInfo.propTypes = {
  formData: PropTypes.shape({
    eventName: PropTypes.string,
    status: PropTypes.string,
    eventType: PropTypes.string,
    eventDateBegin: PropTypes.string,
    eventDateEnd: PropTypes.string,
    description: PropTypes.string,
    locationName: PropTypes.string,
    street: PropTypes.string,
    zip: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    maxParticipants: PropTypes.string,
    tags: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    eventName: PropTypes.string,
    eventDateBegin: PropTypes.string,
    eventDateEnd: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};
